import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  estado: {
    fontWeight: 'inherit',
    fontSize: '.9rem',
    borderRadius: '.5rem',
    padding: '.4rem .8rem',
    marginLeft: '1rem',
  },
}))

export default useStyles
